// extracted by mini-css-extract-plugin
export const amount = "RewardDetailsRow__amount__TJhZP";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buy = "RewardDetailsRow__buy__0IDWg";
export const description = "RewardDetailsRow__description__Gtj1Z";
export const dismissButtonWrapper = "RewardDetailsRow__dismissButtonWrapper__kEJGh";
export const earned = "RewardDetailsRow__earned__pkBCt";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const name = "RewardDetailsRow__name__nHvus";
export const regular = "RewardDetailsRow__regular__SwB52";
export const sans = "'sans'";
export const sell = "RewardDetailsRow__sell__hC1L6";
export const semibold = "600";
export const serif = "'serif'";
export const statusCopy = "RewardDetailsRow__statusCopy__wvFjI";